import { h } from "preact";
import { useState, useContext } from "preact/hooks";

import { makeStyles } from "@mui/styles";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";

import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";

import NavPrimaryButtonMk2 from "../../theme/NavPrimaryButtonMk2";
import NavSecondaryButtonMk2 from "../../theme/NavSecondaryButtonMk2";

import Logo from "./Logo";
import UserIcon from "./UserIcon";

import MiniSearchBar from "./MiniSearchBar";
import { SessionContext } from "../../SessionContext";

const useStyles = makeStyles((theme) => ({
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "block",
    },
  },

  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
  sectionMobile: {
    display: "flex",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
}));

export default function HeaderAnonyme() {
  console.log("render header anonyme")
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState(null);
  const [state, setState] = useContext(SessionContext);
  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const menuId = "menu-desktop";

  const mobileMenuId = "menu-mobile";
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem>
        <p>{scrollY} Acheter</p>
      </MenuItem>
      <MenuItem>
        <p>Vendre</p>
      </MenuItem>
      <MenuItem onClick={handleProfileMenuOpen}>
        <p>Devenir ambassadeur</p>
      </MenuItem>
      <MenuItem onClick={handleProfileMenuOpen}>
        <p>Se connecter</p>
      </MenuItem>
      <MenuItem onClick={handleProfileMenuOpen}>
        <p>S'inscrire</p>
      </MenuItem>
    </Menu>
  );

  return (
    <div className={classes.grow}>
      <AppBar position="fixed" style="background-color: white">
        {/* <Toolbar style="height: 83px"> */}
        <Toolbar style="height: 83px; display: flex; justify-content: space-between; align-items: center">
          <IconButton onClick={() => { window.location.href = "https://www.bkeys.com" }} >
            <Logo color="primary" />
          </IconButton>
          {window.location.href.startsWith("https://demo.bkeys.com") && <div><Typography variant={"h5"}>SITE DEMO</Typography></div>}

          {/* <div className={classes.grow}>{state.minibar && <MiniSearchBar />}</div> */}
          <div className={classes.sectionDesktop}>
            <NavSecondaryButtonMk2 onClick={() => { window.location.href = "https://www.bkeys.com/acheter" }} style="color: black;">
              Acheter
            </NavSecondaryButtonMk2>
            <NavSecondaryButtonMk2 onClick={() => { window.location.href = "https://www.bkeys.com/vendre" }} style="color: black;">
              Vendre
            </NavSecondaryButtonMk2>
            <NavPrimaryButtonMk2
              href="https://www.bkeys.com/ambassadeur"
              txt="Devenir ambassadeur"
              cb={() => {
                window.location.replace("https://www.bkeys.com/ambassadeur");
              }}
            />

            <IconButton
              edge="end"
              aria-label="account of current user"
              aria-controls={menuId}
              aria-haspopup="true"
              onClick={handleProfileMenuOpen}
              color="inherit"
              href="/login"
              style="padding: 0px;"
            >
              <UserIcon color="primary" />
            </IconButton>
          </div>
          <div className={classes.sectionMobile}>
            <IconButton aria-label="show more" aria-controls={mobileMenuId} aria-haspopup="true" onClick={handleMobileMenuOpen} color="inherit">
              <MenuIcon />
            </IconButton>
          </div>
        </Toolbar>
      </AppBar>
      {renderMobileMenu}
    </div >
  );
}
